import { IExtendedCustomerBPA } from 'types';
import { IBpaContext } from './bpaContext';

export enum BpaActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	CHANGE_BPA = 'CHANGE_BPA',
	ADD_BPA_BLOCK = 'ADD_BPA_BLOCK',
	UPDATE_BPA = 'UPDATE_BPA',
	SET_FETCHED_ACQUIRERS = 'SET_FETCHED_ACQUIRERS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: BpaActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IBpaContext['needRefetchData'];
	};
}

interface ISetInitialFormData {
	type: BpaActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IBpaContext['initialFormData'];
	};
}

interface IChangeBpa {
	type: BpaActionTypes.CHANGE_BPA;
	payload: {
		bpa: IBpaContext['bpa'];
	};
}

interface IAddBpaBlock {
	type: BpaActionTypes.ADD_BPA_BLOCK;
	payload: {
		bpa: IExtendedCustomerBPA;
	};
}

interface ISetDataForSubmit {
	type: BpaActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IBpaContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: BpaActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IBpaContext['typeOfModalWindow'];
	};
}

export type TBpaAction =
	| IRefetchData
	| ISetInitialFormData
	| IChangeBpa
	| IAddBpaBlock
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
